(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl--announcement-banner-5"] && !Shopify.designMode) return;
  try {
    
  const duplicateBannerContent = () => {
    const parents = document.querySelectorAll('[banner-data="parent"]')

    if (parents.length === 0) return

    for (const parent of parents) {
      const child = parent.querySelector('[banner-data="duplicate"]')
      if (!child) continue

      if (parent.children.length > 1) continue

      const duplicate = child.cloneNode(true)
      parent.appendChild(duplicate)
    }
  }

  // Handle initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', duplicateBannerContent)
  } else {
    duplicateBannerContent()
  }

  // Handle theme editor changes
  document.addEventListener('shopify:section:load', duplicateBannerContent)
  document.addEventListener('shopify:section:reorder', duplicateBannerContent)

  } catch(e) { console.error(e); }
})();
})();
